import { c as _c } from "react-compiler-runtime";
import { useResizeObserver } from "@react-aria/utils";
import * as React from "react";
export default function useTextFit(text, t0, t1, t2, t3) {
  const $ = _c(13);
  const minFontSize = t0 === undefined ? 10 : t0;
  const maxFontSize = t1 === undefined ? 100 : t1;
  const padding = t2 === undefined ? 0 : t2;
  const step = t3 === undefined ? 1 : t3;
  const textRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const initialRender = React.useRef(true);
  let t4;
  if ($[0] !== maxFontSize || $[1] !== minFontSize || $[2] !== padding || $[3] !== step) {
    t4 = () => {
      if (!textRef.current || !containerRef.current) {
        return;
      }
      let currentSize = maxFontSize;
      textRef.current.style.fontSize = `${currentSize}px`;
      while (currentSize > minFontSize && (textRef.current.scrollWidth + padding > containerRef.current.clientWidth || textRef.current.scrollHeight + padding > containerRef.current.clientHeight)) {
        currentSize = currentSize - step;
        textRef.current.style.fontSize = `${currentSize}px`;
      }
    };
    $[0] = maxFontSize;
    $[1] = minFontSize;
    $[2] = padding;
    $[3] = step;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onResize = t4;
  let t5;
  if ($[5] !== onResize) {
    t5 = () => {
      if (initialRender.current) {
        initialRender.current = false;
        return;
      }
      const timeout = setTimeout(onResize, 50);
      return () => {
        clearTimeout(timeout);
      };
    };
    $[5] = onResize;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onResize || $[8] !== text) {
    t6 = [onResize, text];
    $[7] = onResize;
    $[8] = text;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  React.useEffect(t5, t6);
  let t7;
  if ($[10] !== onResize) {
    t7 = {
      ref: containerRef,
      onResize
    };
    $[10] = onResize;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  useResizeObserver(t7);
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      textRef,
      containerRef
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
//# sourceMappingURL=useTextFit.js.map